import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container, AppBar, Toolbar, Typography, Box, Grid, Paper, CircularProgress } from "@mui/material";
import Atras from "./atras";
import BottomNav from "./BottomNav";
import { auth, db } from "../firebase";
import { collection, query, where, getCountFromServer, doc, getDoc } from "firebase/firestore";

const StatCard = ({ label, value, color = "primary.main" }) => (
  <Grid item xs={6}>
    <Paper sx={{ p: 2, textAlign: "center" }} variant="outlined">
      <Typography variant="h4" sx={{ color }}>
        {value}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Paper>
  </Grid>
);

const Activity = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [userType, setUserType] = useState(null);
  const [stats, setStats] = useState({});

  useEffect(() => {
    const fetchStats = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate("/login");
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        const type = userDoc.exists() ? userDoc.data().userType : null;
        setUserType(type);

        if (type === "freelancer") {
          const proposalsRef = collection(db, "proposals");
          const [total, accepted, rejected, pending] = await Promise.all([
            getCountFromServer(query(proposalsRef, where("freelanceUid", "==", user.uid))),
            getCountFromServer(query(proposalsRef, where("freelanceUid", "==", user.uid), where("status", "==", "accepted"))),
            getCountFromServer(query(proposalsRef, where("freelanceUid", "==", user.uid), where("status", "==", "rejected"))),
            getCountFromServer(query(proposalsRef, where("freelanceUid", "==", user.uid), where("status", "==", "pending"))),
          ]);
          setStats({
            enviadas: total.data().count,
            aceptadas: accepted.data().count,
            rechazadas: rejected.data().count,
            pendientes: pending.data().count,
          });
        } else {
          const projectsRef = collection(db, "projects");
          const [total, abiertos, enProgreso, cerrados] = await Promise.all([
            getCountFromServer(query(projectsRef, where("uid", "==", user.uid))),
            getCountFromServer(query(projectsRef, where("uid", "==", user.uid), where("status", "==", "abierto"))),
            getCountFromServer(query(projectsRef, where("uid", "==", user.uid), where("status", "==", "en_progreso"))),
            getCountFromServer(query(projectsRef, where("uid", "==", user.uid), where("status", "==", "cerrado"))),
          ]);
          setStats({
            publicados: total.data().count,
            abiertos: abiertos.data().count,
            enProgreso: enProgreso.data().count,
            cerrados: cerrados.data().count,
          });
        }
      } catch (error) {
        console.error("Error fetching activity stats:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, [navigate]);

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Atras />
          <Typography variant="h6" color="text.primary">
            Mi actividad
          </Typography>
        </Toolbar>
      </AppBar>
      <Container sx={{ mt: 15, mb: 14 }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : userType === "freelancer" ? (
          <Grid container spacing={2}>
            <StatCard label="Propuestas enviadas" value={stats.enviadas} />
            <StatCard label="Aceptadas" value={stats.aceptadas} color="success.main" />
            <StatCard label="Rechazadas" value={stats.rechazadas} color="error.main" />
            <StatCard label="Pendientes" value={stats.pendientes} color="warning.main" />
          </Grid>
        ) : (
          <Grid container spacing={2}>
            <StatCard label="Proyectos publicados" value={stats.publicados} />
            <StatCard label="Abiertos" value={stats.abiertos} color="success.main" />
            <StatCard label="En progreso" value={stats.enProgreso} color="warning.main" />
            <StatCard label="Cerrados" value={stats.cerrados} />
          </Grid>
        )}
      </Container>
      <BottomNav />
    </Container>
  );
};

export default Activity;
